import { useState } from 'react';
import { AssistanceForm, IncidentTracking } from './components';
import { Grid, Typography } from '@material-ui/core';
import DefaultButton from 'components/DefaultButton';
import useStyles from './styles';
import { useTheme } from "@material-ui/core/styles";

const HELP_TABS = {
  Assistance: 'Assistance',
  IncidentsTracking: 'IncidentsTracking',
};

const Help = () => {
  const classes = useStyles();
  const theme = useTheme();
  const [currentTab, setCurrentTab] = useState(HELP_TABS.Assistance);

  return (
    <Grid container justifyContent='center' alignItems='center' spacing={3}>
      <Grid container item xs={12} justifyContent='center'>
        <Typography variant='h1'>Assistance</Typography>
      </Grid>

      <Grid container item xs={8} direction='column' alignItems='center' style={{marginTop:80}}>
        <Grid container justifyContent='center' >
          <DefaultButton
            className={ currentTab === HELP_TABS.Assistance ? classes.selectedButton : classes.helpButton }
            style={{marginRight: theme.spacing(3)}}
            color={currentTab === HELP_TABS.Assistance ? 'primary' : 'default'}
            variant={currentTab === HELP_TABS.Assistance ? 'contained' : 'outlined'}
            standard={currentTab === HELP_TABS.Assistance}
            onClick={() => setCurrentTab(HELP_TABS.Assistance)}
          >
            Assistance
          </DefaultButton>
          <DefaultButton
            className={ currentTab === HELP_TABS.IncidentsTracking ? classes.selectedButton : classes.helpButton }
            color={currentTab === HELP_TABS.IncidentsTracking ? 'primary' : 'default'}
            variant={currentTab === HELP_TABS.IncidentsTracking ? 'contained' : 'outlined'}
            standard={currentTab === HELP_TABS.IncidentsTracking}
            onClick={() => setCurrentTab(HELP_TABS.IncidentsTracking)}
          >
            Suivi incident
          </DefaultButton>
        </Grid>
        {currentTab === HELP_TABS.Assistance && <AssistanceForm />}
        {currentTab === HELP_TABS.IncidentsTracking && <IncidentTracking />}
      </Grid>
    </Grid>
  );
};

export default Help;
